/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-07-27 17:25:15
 * @LastEditTime: 2022-03-21 15:39:04
 * @FilePath: /teacher-h5/src/service/students/index.js
 */
import http from '../http'
import url from './index-url'
const { post, get } = http

export default {
  getStudentList(data) {
    return get(url.studentList, data)
  },
  delStudent(data) {
    return post(url.delStudent, data)
  },
  addStudent(data) {
    return post(url.addStudent, data)
  },
  updateStudent(data) {
    return post(url.updateStudent, data)
  },
  activateCard(data) {
    return post(url.activate, data)
  },
  getInsStudents(data) {
    return get(url.insStudents, data)
  },
  getGradeList(data) {
    return get(url.gradeList, data)
  },
  getBookversionList(data) {
    return get(url.bookVersionList, data)
  },
  getRankList(data) {
    return get(url.rankList, data)
  },
  getStudentDetail(data) {
    return get(url.studentDetail, data)
  },
  getPaymentRecords(data) {
    return get(url.paymentRecords, data)
  },
  getCardDetail(data) {
    return get(url.cardDetail, data)
  },
  addCard(data) {
    return post(url.addCard, data)
  },
  getByPhone(data) {
    return get(url.getByPhone, data)
  },
  addTest(data) {
    return post(url.addTest, data)
  },
  getTestCard(data) {
    return get(url.getTestCard, data)
  },
  sendValidMsg(data) {
    return get(url.sendValidMsg, data)
  },
  sendValidMsg2(data) {
    return get(url.sendValidMsg2, data)
  },
  subjectAndGrade(data) {
    return get(url.subjectAndGrade, data)
  },
  getJzxStudents(data) {
    return get(url.getJzxStudents, data)
  },
  batchAdd(data) {
    return post(url.batchAdd, data)
  },
  resetPwd(data) {
    return get(url.resetPwd, data)
  },

  getGroupList(data) {
    return get(url.getGroupList, data)
  },
  getGroupPageList(data) {
    return get(url.getGroupPageList, data)
  },
  addGroupStudent(data) {
    return post(url.addGroupStudent, data)
  },
  delGroup(data) {
    return post(url.delGroup, data)
  },
  createGroup(data) {
    return post(url.createGroup, data)
  },
  getGroupStudent(data) {
    return get(url.getGroupStudent, data)
  },
  sortGroup(data) {
    return post(url.sortGroup, data)
  },
  updateGroup(data) {
    return post(url.updateGroup, data)
  },
  batchDelStudent(data) {
    return post(url.batchDelStudent, data)
  },
  validMsg(data) {
    return get(url.validMsg, data)
  },
  getTeacherList(data) {
    return get(url.getTeacherList, data)
  },
  groupUserList(data) {
    return get(url.groupUserList, data)
  },
  batchAddStudent(data) {
    return post(url.batchAddStudent, data)
  },
  queryErrorList(data) {
    return get(url.queryErrorList, data)
  },
  submitExcel(data) {
    return get(url.submitExcel, data)
  },
  deleteStudent(data) {
    return post(url.deleteStudent, data)
  },
  updateExcel(data) {
    return post(url.updateExcel, data)
  },
  uploadExecl(data, config) {
    return post(url.batchSaveStudentInfo, data, config)
  },
  removeGroupStudent(data) {
    return post(url.removeGroupStudent, data)
  }
}